const INITIALS_LENGTH = 3;

/**
 * @description Gets the initials of a company name, the same way the API does.
 * "Acme Events Ltd" gives "AEL" and "Acme" gives "ACM".
 * A name with no letters or digits gives an empty string.
 * @param {string} companyName
 */
function getCompanyInitials(companyName) {
  const words = (companyName || '').split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  const isSingleWord = words.length === 1;
  const initials = isSingleWord
    ? Array.from(words[0]).slice(0, INITIALS_LENGTH)
    : words.slice(0, INITIALS_LENGTH).map(function (word) {
        return Array.from(word)[0];
      });
  return initials.join('').toUpperCase();
}

export default getCompanyInitials;
